import Blockly from 'blockly/browser'
import Util, { defineBlock, defineStmtBlock, getOptionsCode } from '../Util'

// Automatically generated field
defineBlock(
  'sirenia_api_autofield',
  {
    message0: '🏷 %1',
    args0: [
      {
        type: 'field_input',
        name: 'fieldName',
        text: 'default'
      }
    ],
    output: 'Field',
    colour: Util.colors.field,
    tooltip: 'Application field',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#fields'
  },
  function(block) {
    var valueFieldName = `"${block.getFieldValue('fieldName')}"`
    var code = `Fields[${valueFieldName}]`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  },
  function() {
    this.setEditable(false)
  }
)

// new Field(..)
defineBlock(
  'sirenia_api_dynamic_field',
  {
    message0: '🏷 selector field %1',
    args0: [
      {
        type: 'input_value',
        name: 'fieldPath',
        check: 'String'
      }
    ],
    output: 'Field',
    tooltip: 'Dynamically create a path based field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#fields'
  },
  function(block) {
    var valueFieldPath = Blockly.JavaScript.valueToCode(
      block,
      'fieldPath',
      Blockly.JavaScript.ORDER_ATOMIC
    )
    var code = `new Field(${valueFieldPath || ''})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

// .clickXX(..) TODO: support for offsets - via mutator or second block?
defineStmtBlock(
  'sirenia_api_field_click',
  {
    message0: '%1 click on 🏷%2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'CLICK_KIND',
        options: [['left', 'LEFT'], ['right', 'RIGHT'], ['double', 'DOUBLE']]
      },
      {
        type: 'input_value',
        name: 'field',
        check: 'Field'
      }
    ],
    tooltip: 'Click',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#click',
    mutator: 'sirenia_deadline_mutator'
  },
  function(block) {
    let field =
      Blockly.JavaScript.valueToCode(block, 'field', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let clickKind = block.getFieldValue('CLICK_KIND')
    let clickMethod =
      clickKind === 'RIGHT' ? 'rightClick' : clickKind === 'DOUBLE' ? 'doubleClick' : 'click'
    let optionsObject = getOptionsCode(this.chosenProps, block)
    return `${field}.${clickMethod}(${optionsObject});\n`
  }
)

// .simulateClick
defineStmtBlock(
  'sirenia_api_field_simulate_click',
  {
    message0: 'simulate click on 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'field',
        check: 'Field'
      }
    ],
    tooltip: `Alternative left click strategy. For when the regular left click doesn't cut it`,
    colour: Util.colors.field,
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#simulated-click'
  },
  function(block) {
    let field =
      Blockly.JavaScript.valueToCode(block, 'field', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    return `${field}.simulateClick();\n`
  }
)

// .editCell
defineBlock(
  'sirenia_api_edit_cell',
  {
    message0: 'set cell in row with %2 and in column with %3 to %4 in table 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'tableField',
        check: 'Field'
      },
      {
        type: 'input_value',
        name: 'rowMatch',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'colMatch',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'value',
        check: 'String'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Edit table cell',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#edit-cell',
    mutator: 'sirenia_reflection_depth_mutator'
  },
  function(block) {
    let valueTableField =
      Blockly.JavaScript.valueToCode(block, 'tableField', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let valueRowMatch =
      Blockly.JavaScript.valueToCode(block, 'rowMatch', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let valueColMatch =
      Blockly.JavaScript.valueToCode(block, 'colMatch', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let valueValue =
      Blockly.JavaScript.valueToCode(block, 'value', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let optionsObject = getOptionsCode(this.chosenProps, block)
    let code = `${valueTableField}.editCell(${valueRowMatch}, ${valueColMatch}, ${valueValue}, ${optionsObject});\n`
    return code
  }
)

// .clickCell
defineBlock(
  'sirenia_api_click_cell',
  {
    message0: 'click cell in row with %2 and in column with %3 in table 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'tableField',
        check: 'Field'
      },
      {
        type: 'input_value',
        name: 'rowMatch',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'colMatch',
        check: 'String'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Click table cell',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#click-cell',
    mutator: 'sirenia_reflection_depth_deadline_mutator'
  },
  function(block) {
    let valueTableField =
      Blockly.JavaScript.valueToCode(block, 'tableField', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let valueRowMatch =
      Blockly.JavaScript.valueToCode(block, 'rowMatch', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let valueColMatch =
      Blockly.JavaScript.valueToCode(block, 'colMatch', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let optionsObject = getOptionsCode(this.chosenProps, block)
    let code = `${valueTableField}.clickCell(${valueRowMatch}, ${valueColMatch}, ${optionsObject});\n`
    return code
  }
)

// .read
defineBlock(
  'sirenia_api_field_read',
  {
    message0: 'value from 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'field',
        check: 'Field'
      }
    ],
    output: null,
    tooltip: 'Reads text from a field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#read'
  },
  function(block) {
    var valueField =
      Blockly.JavaScript.valueToCode(block, 'field', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var code = `${valueField}.read()`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

// .inspect
defineBlock(
  'sirenia_api_field_inspect',
  {
    message0: 'inspection object from 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'field',
        check: 'Field'
      }
    ],
    output: 'object',
    tooltip: 'Fields[..].inspect()',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#inspect',
    mutator: 'sirenia_reflection_depth_mutator'
  },
  function(block) {
    var valueField =
      Blockly.JavaScript.valueToCode(block, 'field', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let optionsObject = getOptionsCode(this.chosenProps, block)
    var code = `${valueField}.inspect(${optionsObject})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

// .select TODO: add support for offset and skip - use options mutator
defineStmtBlock(
  'sirenia_api_field_select',
  {
    message0: 'select %1 on 🏷%2',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    inputsInline: true,
    tooltip: 'Selects an item identified by a matching value and a field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#select',
    mutator: 'sirenia_reflection_depth_deadline_mutator'
  },
  function(block) {
    var value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var field =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    let optionsObject = getOptionsCode(this.chosenProps, block)
    var code = `${field}.select(${value}, ${optionsObject});\n`
    return code
  }
)

// .selectIndex
defineStmtBlock(
  'sirenia_api_field_select_index',
  {
    message0: 'select #%1 on 🏷%2',
    args0: [
      {
        type: 'input_value',
        name: 'INDEX',
        check: 'Number'
      },
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    inputsInline: true,
    tooltip: 'Selects an entry by index on a field representing a dropdown, listbox or tree-view',
    colour: Util.colors.field,
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#select-with-index'
  },
  function(block) {
    var index =
      Blockly.JavaScript.valueToCode(block, 'INDEX', Blockly.JavaScript.ORDER_ATOMIC) || '0'
    var field =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var code = `${field}.selectIndex(${index});\n`
    return code
  }
)

// .input
defineStmtBlock(
  'sirenia_api_field_input',
  {
    message0: 'enter text %1 into 🏷%2',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE'
      },
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    inputsInline: true,
    tooltip: 'Puts text into specified application field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#input'
  },
  block => {
    var value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var field =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var code = `${field}.input(${value});\n`
    return code
  }
)

// .inputNative
defineStmtBlock(
  'sirenia_api_field_input_native',
  {
    message0: 'simulate keys %1 into 🏷%2',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE'
      },
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    inputsInline: true,
    tooltip: 'Simulates key presses into specified application field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#input',
    mutator: 'sirenia_delay_mutator'
  },
  function(block) {
    var value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var field =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var delayCode = ''
    if (this.chosenProps && this.chosenProps.length > 0 && this.chosenProps[0] === 'delay') {
      delayCode = `, ${Blockly.JavaScript.valueToCode(
        block,
        'delay',
        Blockly.JavaScript.ORDER_ATOMIC
      ) || '0'}`
    }
    var code = `${field}.inputNative(${value}${delayCode});\n`
    return code
  }
)

// .exists
defineBlock(
  'sirenia_api_field_exists',
  {
    message0: '🏷%1 exists',
    args0: [
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    output: 'Boolean',
    tooltip: 'Can we currently find the field in the application?',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#inspect'
  },
  function(block) {
    var valueField =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var code = `${valueField}.exists()`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

// .highlight
defineStmtBlock(
  'sirenia_api_field_highlight',
  {
    message0: 'highlight in %1 🏷%2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'COLOR',
        options: [['red', 'RED'], ['green', 'GREEN'], ['blue', 'BLUE']]
      },
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    tooltip: 'Highlight field with a coloured rectangle',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#highlight'
  },
  function(block) {
    const valueField =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    const highlightColor = block.getFieldValue('COLOR') || 'RED'
    const methodName = highlightColor === 'RED' ? 'highlight' : 'highlightWithColor'
    const colorArg = highlightColor === 'RED' ? '' : `'${highlightColor.toLowerCase()}'`
    return `${valueField}.${methodName}(${colorArg});\n`
  }
)

// .lowlight
defineStmtBlock(
  'sirenia_api_field_lowlight',
  {
    message0: 'cancel highlight 🏷%1',
    args0: [
      {
        type: 'input_value',
        name: 'FIELD',
        check: 'Field'
      }
    ],
    tooltip: 'Cancel highlight on field',
    colour: Util.colors.field,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#lowlight'
  },
  function(block) {
    const valueField =
      Blockly.JavaScript.valueToCode(block, 'FIELD', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    return `${valueField}.lowlight();\n`
  }
)
